<template>
  <div class="about">
    <div class="about-page-wrapper banner-wrapper" id="banner">
      <div class="banner-bg-wrapper">
        <div class="banner-bg">
          <img src="../assets/img/about-bg.jpg" />
        </div>
        <div class="banner-bg-hider"></div>
      </div>
      <div class="banner page">
        <div class="text-wrapper" style="opacity: 1;">
          <h1 class="">Do more. <br/> Make friends. <br/> Find activities.</h1>
          <p class=""><span>A platform that gives you the ability to make the most out of your social life.</span></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "about"
};
</script>
